import React, {useEffect} from 'react';
import {Form, Grid, Divider, Header} from 'semantic-ui-react';

const AdditionalInfo = ({formData, setFormData, reduxData, disabled}) => {
  const currentCourse = (reduxData.courses || []).find((c) => {
    return String(c.id) === String(formData.idCursoReferencia);
  });

  const directedToRaw = formData.directed_to ||
    formData.destinatarios ||
    formData.course_destinatarios ||
    [];

  const directedToIds = directedToRaw.map((d) => {
    if (typeof d === 'object' && d !== null) {
      return String(d.id || d.idCursoDestino || d.course_id_destino);
    }
    return String(d);
  });

  const filteredCourses = (reduxData.courses || []).filter((c) => {
    if (!currentCourse) {
      return false;
    }
    return String(c.courseArea) === String(currentCourse.courseArea) &&
      String(c.id) !== String(formData.idCursoReferencia);
  }).map((c) => ({
    ...c,
    'isPrevio': directedToIds.includes(String(c.id)),
  }));
  
  useEffect(() => {
    if (currentCourse && !formData.descripcion) {
      setFormData((prev) => ({
        ...prev,
        'descripcion': currentCourse.courseObservation || '',
      }));
    }
  }, [formData.idCursoReferencia, currentCourse, setFormData]);

  return (
    <>
      <Divider horizontal style={{'margin': '1.5rem 0'}}>
        <Header as="h4">Dirigido A</Header>
      </Divider>
      <Grid.Row style={{'paddingTop': '0'}}>
        <Grid.Column>
          <div style={{
            'maxHeight': '120px',
            'overflowY': 'auto',
            'padding': '10px',
            'border': '1px solid #eee',
            'backgroundColor': disabled ? '#f9f9f9' : 'transparent',
            'fontSize': '0.95rem',
          }}>
            {disabled ? (
              <p style={{'textAlign': 'center', 'color': '#999'}}>
                Seleccione un curso para ver los destinatarios
              </p>
            ) : (
              filteredCourses.map((c) => (
                <Form.Checkbox
                  key={c.id}
                  label={c.course || c.description}
                  checked={c.isPrevio}
                  readOnly
                  style={{'marginBottom': '8px', 'opacity': '1'}}
                />
              ))
            )}
            {!disabled && filteredCourses.length === 0 && (
              <p style={{'textAlign': 'center', 'color': '#999'}}>
                No hay cursos disponibles para este área
              </p>
            )}
          </div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Form.Field>
            <label>Observaciones</label>
            <div style={{
              'padding': '10px',
              'border': '1px solid rgba(34,36,38,.15)',
              'borderRadius': '4px',
              'backgroundColor': '#f9f9f9',
              'minHeight': '120px',
              'fontSize': '1rem',
              'color': 'rgba(0,0,0,.87)',
              'whiteSpace': 'pre-wrap',
            }}>
              {formData.descripcion || ''}
            </div>
          </Form.Field>
        </Grid.Column>
      </Grid.Row>
    </>
  );
};

export default AdditionalInfo;
